<script>
import DeviceStateHistoryProductivity from '@components/vis-device-state-productivity'

import {
  deviceEventCurrentComputed,
  infoMethods,
  infoDetailsMethods,
  deviceEventCurrentMethods,
  infoDetailsComputed,
} from '@state/helpers'

import { statusCssBackgroundClass } from '@utils/design/status-css-classes'

import { cycleCssClass } from '@utils/design/cycle-css-classes'

import { durationSinceEvent } from '@utils/data/date-time'

import { cyclePercentage } from '@utils/data/cycle'

export default {
  name: 'CDeviceStatus',

  components: { DeviceStateHistoryProductivity },

  props: {
    deviceEventCurrent: {
      type: Object,
      default: () => {},
    },
  },

  computed: {
    ...deviceEventCurrentComputed,
    ...infoDetailsComputed,

    cyclePercentageComputed: function() {
      return cyclePercentage(this.$moment, this.deviceEventCurrent.cycle, Date.now())
    },

    durationSinceEventComputed: function() {
      return durationSinceEvent(this.$moment, this.deviceEventCurrent.startDate)
    },

    cycleCssClassComputed: function() {
      return cycleCssClass(this.cyclePercentageComputed)
    },

    statusCssBackgroundClassComputed: function() {
      return statusCssBackgroundClass(this.deviceEventCurrent.status.type)
    },
  },

  created: function() {
    if (
      this.selectedDefaultObject !== null &&
      this.selectedDefaultObject.device.id === this.deviceEventCurrent.device.id
    ) {
      this.selectDetailsDefault({
        defaultObject: this.deviceEventCurrent,
        detailsType: 'device',
      })
    }
  },

  methods: {
    ...infoMethods,
    ...infoDetailsMethods,
    ...deviceEventCurrentMethods,
  },
}
</script>

<template>
  <b-col v-if="deviceEventCurrent" md="12" lg="12" sm="12" class="p-0">
    <b-card class="state-card state-card-detail" :no-body="true">
      <b-card-body class="card-body device-layout-card-body p-0 ">
        <b-row class="ml-0 mr-0 pl-0 pr-0 device-info-row">
          <b-col md="2" lg="2" sm="12" class="pb-0 m-0 text-uppercase device-info">
            <div class="m-0 ">
              <h5 class=" pt-2 pb-0 mb-1 text-uppercase font-weight-bold clearfix">
                {{ deviceEventCurrent.device.name }}
              </h5>
              <span class="clearfix small">{{
                deviceEventCurrent.device.group.name
              }}</span>
            </div>
          </b-col>

          <b-col md="8" lg="8" sm="12" class="m-0 pr-4 text-uppercase device-info">
            <div class="p-1 cycleProgress">
              <b-progress
                class="progress-xs progress-xs-cycle mt-2"
                :variant="cycleCssClassComputed"
                :value="cyclePercentageComputed"
              />

              <div
                v-if="cyclePercentageComputed <= 100"
                class="text-uppercase float-right mt-2  font-weight-bold"
              >
                {{ cyclePercentageComputed }}%
              </div>

              <div
                v-if="cyclePercentageComputed > 100"
                class="text-uppercase float-right mt-2 font-weight-bold"
              >
                > 100%
              </div>

              <div class="text-uppercase mt-2 font-weight-bold">
                <span>
                  {{ deviceEventCurrent.cycle.name }}
                </span>
              </div>
            </div>
          </b-col>

          <b-col
            md="2"
            lg="2"
            sm="12"
            class="pb-0 m-0 text-uppercase  device-info device-info-detail"
            :class="statusCssBackgroundClassComputed"
          >
            <h5 class="float-right pt-3">
              {{ deviceEventCurrent.status.name }}
            </h5>
          </b-col>
        </b-row>

        <b-row class="ml-0 mr-0 pl-0 pr-0 pt-3 device-info-row">
          <b-col class="col-md-2  pb-2 m-0 text-uppercase  device-info">
            <div class="text-uppercase font-weight-bold ">
              <p class="mb-0"> {{ deviceEventCurrent.activity.name }} </p>
              <span
                class="mr-1"
                :class="
                  deviceEventCurrent.activity.planned == true
                    ? 'text-success'
                    : 'text-danger'
                "
              >
                Planned
              </span>

              <span
                :class="
                  deviceEventCurrent.activity.available == true
                    ? 'text-success'
                    : 'text-danger'
                "
                >Available
              </span>
            </div>
          </b-col>
          <b-col class="col-md-8  b-2 pl-0 m-0 text-uppercase float-left device-info">
            <DeviceStateHistoryProductivity
              :show-labels="false"
              :device="deviceEventCurrent.device"
            />
          </b-col>
          <b-col class="col-md-2 pb-2 m-0 text-uppercase  device-info">
            <div class="text-uppercase font-weight-bold ">
              <div class=" clearfix">
                <span
                  v-if="deviceEventCurrent.cycleRate === 100"
                  class="text-success float-right"
                >
                  {{ deviceEventCurrent.cycleRate }}%
                </span>
                <span v-else class="text-danger float-right">
                  {{ deviceEventCurrent.cycleRate }}%
                </span>
                <span class="float-right"> Rate: </span>
              </div>

              <span class="float-right clearfix">
                {{ deviceEventCurrent.shiftPattern.name }} SHIFT
              </span>
            </div>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>
  </b-col>
</template>

<style>
.device-info-detail {
  color: #ffffff;

  border-bottom-left-radius: 3px;
}
.device-navigate a:hover {
  color: #73818f;
  text-decoration: none;
}
.device-info {
  overflow: hidden;
}
.state-card-detail {
  border: none !important;
}
.state-card .card-footer {
  padding: 0.4em;
}
.device-info-row {
  overflow: hidden;
}
.device-layout-card-body {
  overflow: hidden;
  border-radius: 0;
  padding: 0;
  border: none !important;
}
.cycleProgress {
  min-height: 40px;
}
.progress-xs-cycle {
  min-height: 12px;
}
</style>
